import useEnv from '../composables/useEnv'
import useRestNode from '../composables/useRestNode'
import { useLogger } from '../server/utils/useLogger'

export default function useIsLocalArea(context) {

    const { get } = useRestNode()
    const { networkServiceEndpoint } = useEnv()
    const logger = useLogger()

    // travel network stuff
    const getIsLocalArea = async () => {
        const latLong = context.latLong.split(",")
        let result = {}
        try {
            const url = `${networkServiceEndpoint}/is-local/latitude/${latLong[0]}/longitude/${latLong[1]}`
            logger.info(`travel network: /is-local/latitude/${latLong[0]}/longitude/${latLong[1]}`)
            result = await get(url)
        } catch (error) {
            console.log(error)
        }
        return result.value
    }
    return { getIsLocalArea }
}